module.exports = __webpack_public_path__ + "6354c054683a6733004497b40a047b57.svg";